import { createContext } from 'react';
import { User } from '../../types';

export interface CurrentUserData {
  currentUser?: User;
  hasUnreadMessages?: boolean;
  hasUnreadNotifications?: boolean;
  isLoggedIn?: boolean;
}

export const initialContext: CurrentUserData = {
  isLoggedIn: false
};

export default createContext<CurrentUserData>(initialContext);
